import { render, staticRenderFns } from "./IntegrationsEdit.vue?vue&type=template&id=b982d8aa&scoped=true&"
import script from "./IntegrationsEdit.vue?vue&type=script&lang=ts&"
export * from "./IntegrationsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b982d8aa",
  null
  
)

export default component.exports